import { Action } from "@ngrx/store/src/models";
import { RoleModel } from "../../models/RoleModel";

export const QUERY_AVAILABLE_ROLES_SUCCESS = "[SecurityModule] Query Available Roles Success";

export class QueryAvailableRolesSuccessAction implements Action {
  readonly type: string;

  constructor(public payload: { items: RoleModel[] }) {
    this.type = QUERY_AVAILABLE_ROLES_SUCCESS;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/QueryAvailableRolesSuccessAction.ts